const {isConditionActive} = require('../utils/condition-util'),
	storage = require('../utils/storage'),
	DeepDiff = require('deep-diff');

const FIELD_TYPES = {
		'STORAGE': 'storage:',
		'STORAGE_ARRAY': 'storage[]:',
		'COOKIE': 'cookie:',
		'FRACTION': 'fraction'
	},
	RANDOM_VALUE = Math.random();

function applyConditionalConfiguration(config) {
	if (typeof config !== 'object' || config === null || typeof config.conditionalConfigurations === 'undefined') {
		return config;
	}

	const conditionalsToApply = config.conditionalConfigurations.filter((conCfg) => {
			return conCfg.conditions.some((conditionGroup) => conditionGroup.every(({
				field,
				...condition
			}) => {
				try {
					return isConditionActive(condition, _getValueForField(field));
				} catch (e) {
					console.error('[ADVERT] Something went wrong calculating conditional configurations:', e);

					return false;
				}
			}));
		}),
		mergedConfig = conditionalsToApply.reduce((cfg, conCfg) => {
			return _applyConditional(cfg, conCfg);
		}, JSON.parse(JSON.stringify(config)));

	delete mergedConfig.conditionalConfigurations;

	return mergedConfig;
}

function _applyConditional(applyTo, conditional) {
	conditional.config.forEach((change) => {
		DeepDiff.applyChange(applyTo, {}, change);
	});

	return applyTo;
}

function _getValueForField(field) {
	if (field.startsWith(FIELD_TYPES.STORAGE)) {
		return storage.get(field.slice(FIELD_TYPES.STORAGE.length));
	}

	if (field.startsWith(FIELD_TYPES.STORAGE_ARRAY)) {
		return storage.getArray(field.slice(FIELD_TYPES.STORAGE_ARRAY.length));
	}

	if (field.startsWith(FIELD_TYPES.COOKIE)) {
		return storage.getFromCookie(field.slice(FIELD_TYPES.COOKIE.length));
	}

	if (field === FIELD_TYPES.FRACTION) {
		return RANDOM_VALUE;
	}

	throw new Error('Unknown field');
}

module.exports = {
	applyConditionalConfiguration
};
